// Campus photo for /colleges/emory-university: CC BY-SA 4.0, by Marc Merlin, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAsa_Griggs_Candler_Library_on_the_Quad_at_Emory_University.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/emory-university/; credited under the photo.
const photo = {
    "slug": "emory-university",
    "alt": "The Asa Griggs Candler Library on the Quadrangle at Emory University in Atlanta",
    "src": "/colleges/emory-university/campus-1600.webp",
    "srcSmall": "/colleges/emory-university/campus-800.webp",
    "srcMid": "/colleges/emory-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/emory-university/og.jpg",
    "title": "Asa Griggs Candler Library on the Quad at Emory University",
    "author": "Marc Merlin",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAsa_Griggs_Candler_Library_on_the_Quad_at_Emory_University.jpg",
    "read": "2026-09-30"
};

export default photo;
